export const MENU = {
	OVERVIEW: 'OVERVIEW',
	POWER: 'POWER',
	RACK: 'RACK',
	NETWORK: 'NETWORK',
	BADGE: 'BADGE',
};
